import React from 'react'

import VideoThumb from '../video/VideoThumb'
//import { arrayObj } from '../../utils/utils.js'
import CheckBoxCircle from '../ui/CheckBoxCircle.jsx';


import  '../video/styles/SelectVideos.scss'
const style = {
    'position': 'absolute',
    'right': '4px',
    'top': '4px'
  }



const SelectVideos = (props) => {
  return <div className={"grid video-grid select-videos " + props.class} >
     { props.available_videos.map(video => {
       return props.videos[video] && <div className={" video " + ((props.selected_videos.indexOf(video) !== -1) && "active")} key={`select-video-${video}`} >
       <div className="card marginless">
           <VideoThumb  showDescription={false}
             click={props.playVideo} close={()=>{
               props.playVideo(false)
             }} video={props.videos[video]} class="video-row ">
             <div onClick={(e) => {
                 e.stopPropagation();
                 props.handleToggleSelectedSessionVideo(video) }
               } className="confirm-user">
                 <CheckBoxCircle on={props.selected_videos.indexOf(video) !== -1} ></CheckBoxCircle>
             </div>

           </VideoThumb>
           { props.videosCount[video] && <div className="md-caption" style={style}>{props.videosCount[video]}x</div>
         }

       </div>
      </div>}
     )}

   </div>

}

SelectVideos.defaultProps = {
  videos: {},
  selected_areas_videos:[],
  selected_videos:[],
  videosCount: {}
}

export default SelectVideos;



// WEBPACK FOOTER //
// ./src/components/video/SelectVideos.jsx